<template>
  <Modal
    :show="show"
    :action-text="`Delete ${capitalizedDocumentTypeTitle}`"
    cancel-text=""
    :width="modalWidth"
    :button-props="{ color: 'error', variant: 'outlined' }"
    @action="$emit('delete')"
    @close="$emit('close')"
  >
    <template #title>
      Delete {{ capitalizedDocumentTypeTitle }}
    </template>

    <template #content>
      <div>
        Deleting <span class="text-textDarkest">{{ name }}</span> will permanently
        remove this {{ documentTypeTitle }}.
      </div>
      <div class="mt-4 text-textDarkest">
        Please note: This action cannot be undone.
      </div>
    </template>
  </Modal>
</template>

<script>
import { mapState } from 'pinia';
import { useAppAuthData } from '@/stores/app/authData';
import { capitalize } from 'lodash-es';
import Modal from '@/components/shared/Modal.vue';

export default {
  name: 'DeleteModal',
  components: { Modal },
  props: {
    show: { type: Boolean, default: false },
    name: { type: String, default: '' },
    documentType: { type: String, default: 'job' },
    modalWidth: { type: String, default: 'small' },
  },
  emits: ['delete', 'close'],

  computed: {
    ...mapState(useAppAuthData, ['authData']),
    documentTypeTitle() {
      return {
        job_template: 'template',
      }[this.documentType] || this.documentType;
    },
    capitalizedDocumentTypeTitle() {
      return capitalize(this.documentTypeTitle);
    },
  },
};
</script>
